import './_changeColor';

// 親ラッパーのトグル機能を修正
const HeaderMenuToggle = () => {
  const headerButton = document.getElementsByClassName('js-menu-button')[0];
  if(!headerButton) return;
  
  const container = document.getElementsByClassName('js-menu-wrap')[0];
  const items = container.querySelectorAll('.l-header__items:not(.menu-item-has-children)');
  const line = document.getElementsByClassName('js-menu-line');

  // 通常のメニュー項目のみイベントリスナーを追加（子メニューを持つ項目は除外）
  Array.from(items).forEach(item => {
    item.addEventListener('click', () => {
      Toggle();
    });
  });
  
  const Toggle = () => {
    if(!container.classList.contains('is-open')) {
      container.classList.add('is-open');
      headerButton.classList.add('is-open');
      Array.from(line).forEach((elm) => {
        elm.classList.add('is-open');
      });
    } else {
      container.classList.remove('is-open');
      headerButton.classList.remove('is-open');
      Array.from(line).forEach((elm) => {
        elm.classList.remove('is-open');
      });
    }
  }
  
  headerButton.addEventListener('click', () => {
    if(!container) {
      console.log('メニュー要素が見つかりません');
      return;
    }
    Toggle();
  });
}

HeaderMenuToggle();

const FixMenu = () => {
  const menu = document.getElementsByClassName('js-fix-bottom')[0];
  if(menu) {
    window.addEventListener('scroll', () => {
      let scroll_y = window.scrollY;
      if(scroll_y > 500) {
        menu.classList.add('active');
      }
      if(scroll_y < 500) {
        menu.classList.remove('active');
      }
    })
  }
}

FixMenu();

jQuery(function ($) {
  $(document).ready(function() {
    $('.l-header__list > .menu-item > .l-header__sub-list').hide();
    // PC用：ホバー時
    $('.l-header__list > .menu-item').hover(
        function() {
            if ($(window).width() > 1450) {
                $(this).children('.l-header__sub-list').stop(true, true).fadeIn().css('display','flex');
            }
        },
        function() {
            if ($(window).width() > 1450) {
                $(this).children('.l-header__sub-list').stop(true, true).fadeOut();
            }
        }
    );
 
    // SP用：アコーディオン制御
    $(document).on('click', '.menu-item-has-children.l-header__items > a', function(e) {
      if ($(window).width() <= 1450) {
          e.preventDefault(); // リンク移動をキャンセル
          
          // クリック位置が + ボタンの位置かチェック
          var $menuItem = $(this).parent();
          var rect = this.getBoundingClientRect();
          var clickX = e.clientX - rect.left;
          
          // 右端64pxの領域（+/-ボタンエリア）がクリックされた場合のみ処理
          if (clickX > rect.width - 64) {
              $menuItem.toggleClass('active');
              $menuItem.children('.l-header__sub-list').slideToggle();
          }
      }
    });
    
    // サブメニュー内のリンククリック時にイベント伝播を停止
    $(document).on('click', '.l-header__sub-list a', function(e) {
      e.stopPropagation(); // 親要素へのイベント伝播を停止
    });
  });
});
